export enum TimeIntervalEnum {
  lastSevenDays = 'last_seven_days',
  lastThirtyDays = 'last_thirty_days',
  today = 'today',
}
